import { __decorate } from "tslib";
import { injectable } from "inversify";
let TranslationProvider = class TranslationProvider {
};
TranslationProvider = __decorate([
    injectable()
], TranslationProvider);
export { TranslationProvider };
//# sourceMappingURL=TranslationProvider.js.map